import { createContext, useState } from 'react';
import api from 'services/api';

export const TabelaPrecoContext = createContext();

export const TabelaPrecoProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [tabelaPreco, setTabelaPreco] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getTabelaPreco = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: tabelaPreco?.filter,
        page: tabelaPreco?.page,
        size: tabelaPreco?.size,
        order: tabelaPreco?.order,
        ...payload,
      });
      setTabelaPreco((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <TabelaPrecoContext.Provider
      value={{ getLoading, tabelaPreco, getTabelaPreco }}
    >
      {children}
    </TabelaPrecoContext.Provider>
  );
};
